import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "31",
  "description": "",
  "published": "2018-10-26T00:00:00.000Z",
  "redirect_from": ["/blog/31/swizec/8675"],
  "categories": "Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Came home to a surprise today 😍 `}<a parentName="p" {...{
          "href": "https://t.co/bzrCW0jEBk"
        }}>{`pic.twitter.com/bzrCW0jEBk`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1055664626187173895"
      }}>{`October 26, 2018`}</a></blockquote>
    <p>{`31 is a weird age. It's so… normal.`}</p>
    <p>{`If it wasn't for my girlfriend and my coworkers, I probably wouldn't even have noticed. Just another Thursday trying to get React + D3 2018 wrapped up and perfect.`}</p>
    <p>{`Of course, React did just announce hooks, so I have to update a bunch of my updates 🤔`}</p>
    <p>{`But yeah, 31 is weird.`}</p>
    <p>{`Definitely not a wunderkind anymore. That boat has sailed.`}</p>
    <p>{`Too old to gripe about never making 30 under 30.`}</p>
    <p>{`Too old to gripe about anything age/achievement related, really. What's done is done. Never again will I ever hear `}<em parentName="p">{`"Wow, you're so X for your age”`}</em>{`.`}</p>
    <p>{`Got a career, I think, but in your 30’s, you're supposed to. Everyone does.`}</p>
    <p>{`Got okay income, not spectacular, not terrible. But in your 30’s, that's expected.`}</p>
    <p>{`Not living hand to mouth, yay! A few years ago, I was. But in your 30’s, that's just normal. No medal. No participation award. No pat on your back.`}</p>
    <p>{`Yep, definitely too old for anyone to be impressed by what I've achieved in my life.`}</p>
    <p>{`And yet far too young to complain about old age.`}</p>
    <p>{`Last year, it was funny. Oh noes I'm THIRTY that's so old I'm ancient omg! Ha ha, chuckle. Oh you.`}</p>
    <p><img parentName="p" {...{
        "src": "/01a78012aad23f00fb62318a33625b3a/media-9EwnzGNjvmIG4-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`At 31, nobody thinks that's funny. C'mon kid, you still call your knees left and right. Wait until they're good and bad. Then you can say you're old.`}</p>
    <p>{`But 31 is old enough. You see those first signs of aging.`}</p>
    <p>{`Hair's thinning. Can't deny that one anymore. It's thinning.`}</p>
    <p>{`Reflexes aren't what they used to be. Can't use speed and power in the boxing ring no more. Gotta rely on experience and skill. Punch for punch slugging I get smashed every time.`}</p>
    <p>{`Sometimes I can still overwhelm less experienced fighters with volleys. But then I'm gassed and they get me.`}</p>
    <p>{`Getting harder and harder to keep the fat down, too. I tweak MyFitnessPal to fewer and fewer calories and nothing happens. Pounds stay on, body fat percent remains annoyingly constant.`}</p>
    <p>{`Running hard and fast and far is getting harder, too.`}</p>
    <p>{`Little things. A second here. A little more effort there. Just a smidge of my body saying, `}<em parentName="p">{`"Hey you're not 25 anymore"`}</em>{`. If I wasn't training every day, I wouldn't even notice.`}</p>
    <p>{`But I know my body, and I can tell it's slowing down. Even though I'm in the best shape of my life.`}</p>
    <p>{`Brain too.`}</p>
    <p>{`Brain needs more rest than it used to. Nights are getting longer. Mornings are getting earlier. I can't stay up all night hacking away and being productive anymore.`}</p>
    <p>{`I could. But it's not as productive as it used to be. And I feel it the next day more than I used to.`}</p>
    <p>{`I could push through. Work through the tiredness and the brain fog and all the mistakes you spend fixing the next two days. But part of 31 is that I'm not sure I want to.`}</p>
    <p>{`And that's the biggest shame of turning 31. I've lost some of the foolishness. Lost some of the fuck it let's try it. Gained more of the eh I don't know if that's worth the effort.`}</p>
    <p>{`31 is weird.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      